import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useState } from 'react';
import UITextToolbarIcon from 'rich-text-lib/components/editor/UITextToolbarIcon';
import styled from 'styled-components';
// @ts-expect-error no declaration file
import EmojiPickerWrapper from 'ui-addon-emoji-picker/picker/EmojiPickerWrapper';
// @ts-expect-error no declaration file
import makeAsyncEmojiPickerContent from 'ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent';
import UIBadge from 'UIComponents/badge/UIBadge';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { FocusPlugin } from '../plugins/FocusPlugin';
import { OPEN_EMOJI_POPOVER, INSERT_EMOJI } from 'rich-text-lib/constants/usageTracking';
import { PM_EMOJI_POPOVER, PM_EMOJI } from '../constants/events';
import { Tracker } from '../../utils/usageTracker';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AsyncEmojiPicker = makeAsyncEmojiPickerContent(() => import(
// @ts-expect-error no declaration file
/* webpackChunkName: "emoji-picker" */
'ui-addon-emoji-picker/picker/EmojiPickerContent'));
const KeyboardShortcutBadge = styled(UIBadge).attrs(() => ({
  use: 'koala'
})).withConfig({
  displayName: "InsertEmoji__KeyboardShortcutBadge",
  componentId: "akale4-0"
})([""]);
const KeyboardShortcutContainer = styled.span.withConfig({
  displayName: "InsertEmoji__KeyboardShortcutContainer",
  componentId: "akale4-1"
})(["display:inline-flex;margin-left:5px;gap:3px;"]);
export default function InsertEmoji() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const [isOpen, setIsOpen] = useState(false);
  const insertEmoji = useCallback(({
    native: emoji,
    id
  }) => {
    setIsOpen(false);
    const tr = editorState.tr.insertText(emoji).setMeta(FocusPlugin, {
      focusView: true,
      focusViewPos: editorState.selection.$head
    });
    const newState = editorState.apply(tr);
    setEditorState(newState);
    Tracker.track(PM_EMOJI, {
      action: INSERT_EMOJI,
      method: 'popover',
      value: id
    });
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(EmojiPickerWrapper, {
    popoverProps: {
      placement: 'left top',
      open: isOpen,
      closeOnOutsideClick: true,
      onOpenChange: evt => setIsOpen(evt.target.value),
      onOpenComplete: () => {
        Tracker.track(PM_EMOJI_POPOVER, {
          action: OPEN_EMOJI_POPOVER
        });
      }
    },
    autoFocus: true,
    native: true,
    onClick: insertEmoji,
    PickerContent: AsyncEmojiPicker,
    children: /*#__PURE__*/_jsx(UITooltip, {
      open: isOpen ? false : undefined,
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.tooltips.insertEmoji"
        }), /*#__PURE__*/_jsxs(KeyboardShortcutContainer, {
          children: [/*#__PURE__*/_jsx(KeyboardShortcutBadge, {
            children: "Shift"
          }), /*#__PURE__*/_jsx(KeyboardShortcutBadge, {
            children: ";"
          })]
        })]
      }),
      children: /*#__PURE__*/_jsx(RTEToolbarButton, {
        use: "transparent",
        onClick: () => setIsOpen(() => !isOpen),
        selected: isOpen,
        "aria-label": I18n.text('hubspot-prosemirror.tooltips.insertEmoji'),
        children: /*#__PURE__*/_jsx(UITextToolbarIcon, {
          name: "emoji"
        })
      })
    })
  });
}